import {
  Divider,
  Typography,
} from '@mui/material';
import './FillInTheBlankPreview.scss';
import { BLANK_SPACE } from './FillInTheBlankUtils';
import TextLines from '../../text/TextLines';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const fillInTheBlankExamples = [
  'I like to eat ___ for breakfast.',
  'Which animal barks?___',
  '___ is my first name.',
];

const defaultProps = {
  data: {
    question: {
      preBlank: {
        lines: [],
      },
      postBlank: {
        lines: [],
      },
    },
    answers: [],
  },
};
const FillInTheBlankPreviewWithTextStyle = (props) => {
  const { data } = { ...defaultProps, ...filterUndefined(props) };
  const { question: { preBlank, postBlank } } = data;

  return (
    <div className='fill-in-the-blank-preview'>
      <div className='example'>
        <Typography variant='h6'>
          Example Questions
        </Typography>
        {fillInTheBlankExamples.map((example, index) => (
          <div className='example-text' key={`example-text-${index}`}>{example}</div>
        ))}
      </div>
      <Divider style={{ height: 8 }} />
      <div className='preview'>
        <Typography variant='h6'>
          Your Question
        </Typography>
        <div className='preview-question'>
          <div className='pre-blank'>
            <TextLines textLines={preBlank} />
          </div>
          {BLANK_SPACE}
          <div className='post-blank'>
            <TextLines textLines={postBlank} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FillInTheBlankPreviewWithTextStyle;
